import React, { useEffect } from "react";
import { RouteComponentProps } from "react-router-dom";
import { attach } from "../../common/componentExtensions";
import Form from "./operatorForm";
import NewOperatorForm, { NewOperatore } from "./newOperatorForm";
import Actions from "../operatorsActions";
import Store from "../operatorsStore";
import { UserDataDto } from "../../generated";
import { links } from "../../routes";
import { Loading } from "../../common/components/loading";

interface Props extends RouteComponentProps<{ id: string }> {
    operatore?: UserDataDto;
}
const OperatoreEdit = (props: Props) => {

    let { operatore, history, match: { params: { id } } } = props;
    const isCreate = id == null;

    useEffect(() => {
        if (Store.get(id) == null)
            Actions.getOperatoriByEsercente();
    }, [id])

    const save = (operatore: UserDataDto) => {
        if (id)
            Actions.update(+id, operatore);
        else
            Actions.add(operatore);
        history.push(links.companyOperators)
    }
    if (!id)
        operatore = new UserDataDto();
    else if (!operatore) {
        return <Loading />;
    }
    return (
        <div className="card">
            <div className="card-body pb-0">
                {isCreate
                    ? <NewOperatorForm
                        operatore={{ ...operatore, confirmPassword: "", confirmUsername: "" } as NewOperatore}
                        onSubmit={save}
                        onCancel={() => history.goBack()}
                    />
                    : <Form
                        operatore={operatore}
                        onSubmit={save}
                        onCancel={() => history.goBack()}
                    />
                }
            </div>
        </div>
    );
};


export default attach(OperatoreEdit,
    Store,
    (store, { match: { params: { id } } }) => ({ operatore: store.get(id) ?? undefined })
);